import React from 'react';
import { Info, FileText, ExternalLink, AlertTriangle } from 'lucide-react';

export function ReportsInfo() {
  return (
    <div className="space-y-8">
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <Info className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
          </div>
          <h2 className="card-title">
            Informacje o sprawozdaniach
          </h2>
        </div>
        
        <div className="space-y-4">
          <p className="body-medium">
            Jako organizacja pożytku publicznego, Fundacja Znajdki jest zobowiązana do publikowania sprawozdań finansowych i z działalności zgodnie z obowiązującymi przepisami prawa.
          </p>
          
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="heading-5 mb-4">
              Rodzaje sprawozdań
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <FileText className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
                <div>
                  <strong className="block label-large">Sprawozdanie finansowe</strong>
                  <span className="body-medium text-accessible-gray-600 dark:text-white high-contrast:text-white no-margin">Zawiera informacje o sytuacji finansowej fundacji, w tym bilans, rachunek zysków i strat oraz informację dodatkową.</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <FileText className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
                <div>
                  <strong className="block label-large">Sprawozdanie z działalności</strong>
                  <span className="body-medium text-accessible-gray-600 dark:text-white high-contrast:text-white no-margin">Opisuje działalność fundacji w danym roku, realizowane projekty, osiągnięte cele i podjęte inicjatywy.</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <FileText className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
                <div>
                  <strong className="block label-large">Sprawozdanie z działalności OPP</strong>
                  <span className="body-medium text-accessible-gray-600 dark:text-white high-contrast:text-white no-margin">Szczegółowe sprawozdanie wymagane od organizacji posiadających status Organizacji Pożytku Publicznego.</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <FileText className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
                <div>
                  <strong className="block label-large">Uchwały zarządu</strong>
                  <span className="body-medium text-accessible-gray-600 dark:text-white high-contrast:text-white no-margin">Dokumenty zawierające formalne decyzje zarządu fundacji dotyczące sprawozdań i innych kwestii organizacyjnych.</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <ExternalLink className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
          </div>
          <h2 className="card-title">
            Dodatkowe źródła
          </h2>
        </div>
        
        <div className="space-y-4">
          <p className="body-medium">
            Nasze sprawozdania są również dostępne w następujących miejscach:
          </p>
          
          <ul className="space-y-3">
            <li className="flex items-start gap-2">
              <ExternalLink className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
              <a 
                href="https://sprawozdaniaopp.niw.gov.pl/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="body-medium hover:text-accessible-red-600 transition-colors no-margin"
              >
                Narodowy Instytut Wolności - Sprawozdania OPP
              </a>
            </li>
            <li className="flex items-start gap-2">
              <ExternalLink className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
              <a 
                href="https://ekrs.ms.gov.pl/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="body-medium hover:text-accessible-red-600 transition-colors no-margin"
              >
                Krajowy Rejestr Sądowy
              </a>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="bg-accessible-red-600/10 p-6 rounded-lg">
        <div className="flex items-center gap-3 mb-4">
          <AlertTriangle className="w-5 h-5 text-accessible-red-600" aria-hidden="true" />
          <h3 className="heading-5 text-accessible-red-600 mb-0">
            Potrzebujesz więcej informacji?
          </h3>
        </div>
        <p className="body-medium mb-4 text-accessible-red-600 dark:text-white high-contrast:text-white">
          Jeśli potrzebujesz dodatkowych informacji finansowych lub masz pytania dotyczące naszych sprawozdań, skontaktuj się z nami:
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a href="mailto:znajdki2012@gmail.com" className="link-primary">
            znajdki2012@gmail.com
          </a>
          <a href="tel:+48664821160" className="link-primary">
            tel. 664 821 160
          </a>
        </div>
      </div>
    </div>
  );
}